import { Center, CircularProgress } from '@chakra-ui/react';

export const DefaultProgress = ({ size = '100px' }: { size?: string }) => {
  return (
    <Center>
      <CircularProgress size={size} isIndeterminate color={'primary.400'} />
    </Center>
  );
};
